import { CompanyProfile } from '@mkp/company/models';
import { UUID } from '@mkp/shared/models';
import { createAction, props } from '@ngrx/store';

export const updateCompanySuccess = createAction(
  '[Company API] Update Company Success',
  props<{ company: CompanyProfile }>()
);
export const updateCompanyFailure = createAction(
  '[Company API] Update Company Failure',
  props<{ companyId: UUID; error: { message: string } }>()
);
// The API answers a PATCH that would change nothing with a bodiless 304. Nothing failed,
// so it must not reach the failure path and its red error bar.
export const updateCompanyNoChanges = createAction(
  '[Company API] Update Company No Changes',
  props<{ companyId: UUID }>()
);

export const loadCompanySuccess = createAction(
  '[Company API] Load Company Success',
  props<{ company: CompanyProfile }>()
);
export const loadCompanyFailure = createAction(
  '[Company API] Load Company Failure',
  props<{ companyId: UUID; error: { message: string } }>()
);

export const loadCompanyIfNotExistSuccess = createAction(
  '[Company API] Load Company If Does Not Exist Success',
  props<{ company: CompanyProfile }>()
);
export const loadCompanyIfNotExistFailure = createAction(
  '[Company API] Load Company If Does Not Exist Failure',
  props<{ companyId: UUID; error: { message: string } }>()
);

export const deleteLocationSuccess = createAction(
  '[Company API] Delete Company Profile Location Success',
  props<{ id: UUID; companyProfileId: UUID }>()
);
export const deleteLocationFailure = createAction(
  '[Company API] Delete Company Profile Location Failure',
  props<{ error: { message: string } }>()
);
